import clsx from 'clsx';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { ToggleSwitch } from '@/core/ToggleSwitch.atom';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface ToggleIF extends ValidatingFormComponent<any> {
  component: 'ToggleFormComponent';
  onChange: () => void;
  testId?: string;
  wrapperClasses?: string;
  label: string;
}

export const ToggleFormComponent = (props: ToggleIF) => {
  const {
    name,
    validation,
    testId = 'toggleSwitch',
    wrapperClassNames,
    customErrorText,
    required = false,
    extendValidation,
    onChange,
    label,
    extraClassNames,
  } = props;

  const { t } = useTranslation();

  const formState = useForm().getState();
  const showError =
    _.has(formState.errors, name) &&
    formState.hasValidationErrors &&
    ((formState.modified && formState.modified[name]) || formState.submitFailed);

  const defaultValidation = (value: any) => required && !value;
  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);

  return (
    <>
      <FormFieldWrapper
        wrapperClassNames={clsx('flexFill', wrapperClassNames)}
        testId={testId}
        showError={showError}
        errorClassNames="ml20"
        customErrorText={customErrorText}>
        <Field name={name} validate={appliedValidation}>
          {({ input, meta }) => {
            const { value } = getFormFieldProps(formState, input, meta, props);

            return (
              <ToggleSwitch
                testId={`${testId}-input`}
                isOn={value}
                onChange={() => onChange()}
                label={t(label)}
                extraClassNames={extraClassNames}
              />
            );
          }}
        </Field>
      </FormFieldWrapper>
    </>
  );
};
